import { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { EFinancingOfferType } from '@/types'

export const BANNERS = {
  'AGRICULTURAL-PRODUCTS-BANNER': {
    name: 'agriculturalProducts',
    link: '/agricultural-products',
    title: 'Сельхозтовары всегда под рукой',
    description: 'Сельхозтовары любой категории на выгодных условиях',
    button: 'Искать товары',
  },
  'FERTILIZERS-BANNER': {
    name: 'fertilizers',
    link: '/agricultural-products/1',
    title: 'Удобрения',
    description: 'Что выросло, то удобряли',
    button: 'Купить удобрения',
  },
  'SEEDS-BANNER': {
    name: 'seeds',
    link: '/agricultural-products/2',
    title: 'Семена',
    description: 'Что посеять – знает поле.рф — маркетплейс для аграриев',
    button: 'Купить семена',
  },
  'REMEDIES-BANNER': {
    name: 'remedies',
    link: '/agricultural-products/3',
    title: 'Средства защиты растений',
    description: 'Помогаем защитить будущий урожай',
    button: 'Купить средства защиты растений',
  },
  'FUEL-BANNER': {
    name: 'fuel',
    link: '/agricultural-products/4',
    title: 'ГСМ',
    description: 'Нужен дизель и масла? Вам сюда',
    button: 'Купить ГСМ',
  },
  'AGROTECHNICS-BANNER': {
    name: 'agrotechnics',
    link: '/agricultural-products/5',
    title: 'Новая техника',
    description: 'Новая техника для хорошего урожая',
    button: 'Выбрать',
  },
  'USED-AGROTECHNICS-BANNER': {
    name: 'usedAgrotechnics',
    link: '/agricultural-products/440',
    title: 'Техника с наработкой',
    description: 'Рабочие лошадки в добрые руки',
    button: 'Купить технику с наработкой',
  },
  'TIRES-AND-WHEELS-BANNER': {
    name: 'tiresAndWheels',
    link: '/agricultural-products/259',
    title: 'Шины и диски',
    description: 'Шины и диски для вашей сельхозтехники',
    button: 'Купить',
  },
  'HARVEST-SALE-BANNER': {
    name: 'harvestSale',
    link: '/offer-requests?offset=0',
    title: 'Урожай',
    description: 'Реализовать зерновые и масличные удобно с поле.рф — маркетплейс для аграриев',
    button: 'Продать урожай',
  },
  'FINANCING-BANNER': {
    name: 'financing',
    link: '/financing',
    title: 'Финансовые решения для аграриев',
    description: 'Получите финансирование с учетом сезонности вашего бизнеса',
    button: 'Подобрать финансирование',
  },
} as const

export const FINANCING_WIDGETS = {
  'EXPRESS-MFO': {
    name: 'express-mfo',
    title: 'Заем с выплатой в конце срока',
    description: 'Получите деньги в течение 5 рабочих дней без лишних документов',
    button: 'Получить финансирование',
    financingProductId: FundingProduct.EXPRESS_MFO,
    financingOfferType: EFinancingOfferType.EXPRESS_MFO,
  },
  'ADVANCE-FUNDING': {
    name: 'advance-funding',
    title: 'Авансирование под будущий урожай',
    description: 'Получите деньги под урожай без ежемесячных платежей за 7 рабочих дней',
    button: 'Подать заявку',
    financingProductId: FundingProduct.ADVANCE_FUNDING,
    financingOfferType: EFinancingOfferType.ADVANCE_FUNDING,
  },
  AGENT: {
    name: 'agent',
    title: 'Зарабатывайте вместе с ПолеФинанс',
    description: 'Дополнительный доход без отрыва от основной работы Привлекайте заявки на займы и получайте процент от выдач',
    button: 'Стать агентом',
    financingProductId: FundingProduct.EXPRESS_MFO,
    financingOfferType: EFinancingOfferType.EXPRESS_MFO,
  },
} as const
